var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"rightBottom"}},[_c('div',{staticClass:"lb-title"},[_vm._v("各乡镇候选人情况")]),_c('dv-scroll-board',{staticClass:"lb-content",attrs:{"config":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }